"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackButtonStyled = exports.modifiers = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_components_modifiers_1 = require("styled-components-modifiers");
var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");
exports.modifiers = {
  darkGray: function darkGray(_ref) {
    var theme = _ref.theme;
    return {
      styles: "\n      background-color: ".concat(theme.farmProject.dark_gray, ";\n      border: 1px solid transparent;\n      \n      span {\n        color: ").concat(theme.farmProject.gray_3, ";\n      }\n\n      .Icon {\n        g {\n          g {\n            path {\n              fill: ").concat(theme.farmProject.gray_3, ";\n            }\n          }\n        }\n      }\n      \n      &:hover {\n        border: solid 1px ").concat(theme.farmProject.dark_gray, ";\n        background-color: transparent;\n\n        span {\n          color: ").concat(theme.farmProject.dark_gray, ";\n        }\n\n        .Icon {\n          g {\n            g {\n              path {\n                fill: ").concat(theme.farmProject.dark_gray, " !important;\n              }\n            }\n          }\n        }\n      }\n    ")
    };
  }
};
exports.BackButtonStyled = styled_components_1.default.button.attrs({
  className: 'BackButtonStyled'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 2.725rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0.5rem 0.125rem 0.5rem 0.5rem;\n  transition: all 0.25s ease-in-out;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: 0.25rem;\n  background-color: ", ";\n  cursor: pointer;\n  max-width: 9rem;\n\n  .Icon {\n    width: 1.125rem;\n    height: 1.125rem;\n    margin-right: 0.5rem;\n    flex-shrink: 0;\n  }\n\n  span {\n    font-family: ", ";\n    font-size: 0.625rem;\n    letter-spacing: normal;\n    color: ", ";\n    text-decoration: none;\n    max-width: 5.5rem;\n    line-height: normal;\n    text-align: left;\n    flex-shrink: 0;\n    display: none;\n\n    @media ", " {\n      display: block;\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n    border: 1px solid ", ";\n    span {\n      color: ", ";\n    }\n\n    .Icon {\n      svg {\n        fill: ", ";\n\n        g {\n          g {\n            path {\n              fill: ", ";\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media ", " {\n    padding: 0.5rem 1rem 0.5rem 0.5rem;\n  }\n\n  @media ", " {\n    max-width: 13rem;\n\n    span {\n      font-size: 0.75rem;\n      max-width: 7.5rem;\n    }\n  }\n\n  ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.farmProject.dark_gray;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.farmProject.gray_3;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.farmProject.font_family;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.farmProject.dark_gray;
}, atoms_utils_theme_1.breakPoints.small_break, function (_ref6) {
  var theme = _ref6.theme;
  return theme.farmProject.dark_gray;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.farmProject.dark_gray;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.farmProject.gray_3;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.farmProject.gray_3;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.farmProject.gray_3;
}, atoms_utils_theme_1.breakPoints.small_break, atoms_utils_theme_1.breakPoints.large_break, (0, styled_components_modifiers_1.applyStyleModifiers)(exports.modifiers));